var _path, _g, _g2, _ellipse, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictureWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 307,
    viewBox: "0 0 272 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.659 10.3293C132.857 8.68429 135.311 8.6843 136.509 10.3293L187.014 79.6694C188.458 81.652 187.042 84.4356 184.589 84.4356H83.5789C81.126 84.4356 79.7098 81.652 81.1539 79.6694L131.659 10.3293Z",
    stroke: "#B7B7B7",
    strokeWidth: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_955_22448)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 69.7372,
    width: 272,
    height: 179.727,
    rx: 5,
    fill: "#B7B7B7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_955_22448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.3242,
    y: 85.0331,
    width: 241.352,
    height: 149.135,
    rx: 5,
    fill: "#E5E5E5"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.085,
    cy: 31.4974,
    rx: 11.493,
    ry: 11.4719,
    fill: "#D9D9D9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_955_22448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.4648,
    y: 287.704,
    width: 157.07,
    height: 15.2959,
    rx: 7.64796,
    fill: "#B7B7B7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3393 173.097V146.915H66.6689C68.6547 146.915 70.3464 147.294 71.7441 148.053C73.1419 148.803 74.2072 149.847 74.9402 151.185C75.6816 152.515 76.0524 154.049 76.0524 155.787C76.0524 157.526 75.6774 159.06 74.9274 160.39C74.1774 161.719 73.0907 162.755 71.6674 163.496C70.2527 164.238 68.5396 164.608 66.5282 164.608H59.9444V160.172H65.6334C66.6987 160.172 67.5765 159.989 68.2669 159.622C68.9657 159.247 69.4856 158.732 69.8265 158.076C70.176 157.411 70.3507 156.648 70.3507 155.787C70.3507 154.918 70.176 154.159 69.8265 153.512C69.4856 152.855 68.9657 152.348 68.2669 151.99C67.568 151.624 66.6816 151.441 65.6078 151.441H61.8748V173.097H56.3393ZM85.6934 146.915V173.097H80.1579V146.915H85.6934ZM113.859 156.081H108.259C108.157 155.357 107.948 154.713 107.633 154.151C107.317 153.58 106.913 153.094 106.418 152.693C105.924 152.293 105.353 151.986 104.705 151.773C104.066 151.56 103.371 151.453 102.621 151.453C101.266 151.453 100.086 151.79 99.0802 152.463C98.0745 153.128 97.2947 154.1 96.7407 155.378C96.1867 156.648 95.9097 158.191 95.9097 160.006C95.9097 161.872 96.1867 163.441 96.7407 164.711C97.3032 165.98 98.0873 166.939 99.093 167.587C100.099 168.235 101.262 168.559 102.583 168.559C103.325 168.559 104.011 168.461 104.641 168.265C105.28 168.068 105.847 167.783 106.342 167.408C106.836 167.024 107.245 166.56 107.569 166.015C107.901 165.469 108.131 164.847 108.259 164.148L113.859 164.174C113.714 165.375 113.352 166.534 112.772 167.651C112.201 168.759 111.43 169.752 110.458 170.63C109.495 171.499 108.344 172.189 107.006 172.701C105.677 173.203 104.173 173.455 102.494 173.455C100.158 173.455 98.0703 172.926 96.2293 171.87C94.397 170.813 92.9481 169.283 91.8828 167.28C90.8259 165.277 90.2975 162.853 90.2975 160.006C90.2975 157.151 90.8345 154.722 91.9083 152.719C92.9822 150.716 94.4396 149.191 96.2805 148.142C98.1214 147.086 100.192 146.557 102.494 146.557C104.011 146.557 105.417 146.77 106.712 147.196C108.016 147.622 109.171 148.245 110.177 149.063C111.182 149.872 112.001 150.865 112.631 152.041C113.271 153.218 113.68 154.564 113.859 156.081ZM117.341 151.479V146.915H138.844V151.479H130.828V173.097H125.357V151.479H117.341ZM159.067 146.915H164.602V163.918C164.602 165.827 164.146 167.497 163.234 168.929C162.331 170.361 161.065 171.478 159.438 172.279C157.81 173.071 155.913 173.468 153.749 173.468C151.575 173.468 149.675 173.071 148.047 172.279C146.419 171.478 145.153 170.361 144.25 168.929C143.347 167.497 142.895 165.827 142.895 163.918V146.915H148.43V163.445C148.43 164.442 148.648 165.328 149.082 166.104C149.526 166.88 150.148 167.489 150.949 167.932C151.75 168.375 152.683 168.597 153.749 168.597C154.823 168.597 155.756 168.375 156.548 167.932C157.349 167.489 157.967 166.88 158.402 166.104C158.845 165.328 159.067 164.442 159.067 163.445V146.915ZM169.667 173.097V146.915H179.996C181.973 146.915 183.661 147.269 185.059 147.976C186.465 148.675 187.535 149.668 188.268 150.955C189.009 152.233 189.38 153.738 189.38 155.468C189.38 157.206 189.005 158.702 188.255 159.955C187.505 161.199 186.418 162.154 184.995 162.818C183.58 163.483 181.867 163.816 179.856 163.816H172.939V159.367H178.961C180.018 159.367 180.895 159.222 181.594 158.932C182.293 158.642 182.813 158.208 183.154 157.628C183.503 157.049 183.678 156.328 183.678 155.468C183.678 154.598 183.503 153.865 183.154 153.269C182.813 152.672 182.289 152.22 181.581 151.914C180.883 151.598 180 151.441 178.935 151.441H175.202V173.097H169.667ZM183.806 161.182L190.313 173.097H184.202L177.836 161.182H183.806ZM193.802 173.097V146.915H211.444V151.479H199.337V157.718H210.536V162.282H199.337V168.533H211.495V173.097H193.802Z",
    fill: "#B7B7B7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_955_22448",
    x: -4,
    y: 65.7372,
    width: 280,
    height: 187.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_955_22448"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_955_22448",
    result: "effect2_innerShadow_955_22448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_955_22448",
    x: 11.3242,
    y: 81.0331,
    width: 255.352,
    height: 163.135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_955_22448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_955_22448",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_955_22448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_955_22448",
    x: 53.4648,
    y: 283.704,
    width: 165.07,
    height: 23.2959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_955_22448"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureWordIcon);
export default __webpack_public_path__ + "static/media/picture-word-icon.aef50f89af809bfcc2df86ea715e04fc.svg";
export { ForwardRef as ReactComponent };